import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChatSidebar from "../ChatSidebar/ChatSidebar";

import ChatingArea from "../ChatingArea/ChatingArea";
import "./index.scss";
import MobileSidebar from "../ChatSidebar/MobileSidebar";
import CreateChatProjectModal from "../ChatProjects/CreateChatProjectModal/CreateChatProjectModal";
import ChatProjectsInitialScreen from "../ChatProjects/ChatProjectsInitialScreen/ChatProjectsInitialScreen";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { loadUser } from "../../../../store/features/Auth/AuthApi";


const Conversation = () => {
    const [authFail, setAuthFail] = useState(false);
  const [hashId, setHashId] = useState<string>("111-1111-1111-111-111");
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
      useLayoutEffect(() => {
         dispatch(loadUser({ setAuthFail: setAuthFail }));
       }, []);
       useEffect(() => {
         if (authFail) {
           navigate("/");
         }
       }, [authFail]);
    
  return (
    <div className="conversation__wrappper">
      <ChatSidebar setHashId={setHashId} />
      <MobileSidebar
        showSideBar={showSideBar}
        setShowSideBar={setShowSideBar}
        setHashId={setHashId}
      />

      {/* for a single chat  */}
      <div className="margin__for__chating">
        <ChatingArea hashId={hashId} setShowSideBar={setShowSideBar} />
      </div>

      {/* for Project chat ui only  */}
      {/* <div className="margin__for__chating chatting__area__with">
      
        <ChatProjectsInitialScreen/>
      </div> */}
      <CreateChatProjectModal />
    </div>
  );
};

export default Conversation;
